export const expandAffirmationCode = code => {
  if (code === "Y") return "Yes";

  if (code === "N") return "No";

  return "Not specified";
};

export default expandAffirmationCode;
